import { ReactNode } from "react"

export type NpDiscountPillProps = {
  children: ReactNode
}

export const NpDiscountPill = ({ children }: NpDiscountPillProps) => (
  <div className="bg-np-red flex min-h-7 items-center justify-center gap-1 rounded-full px-3 py-1 text-sm font-medium text-white">
    {children}
  </div>
)
